var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container mt-3_25 xl_mt-5 mx-auto pl-_5 md_px-1" },
    [
      _c(
        "div",
        {
          staticClass:
            "md_border border-brand-secondary-600 flex flex-wrap md_px-_75 md_pb-1_25"
        },
        [
          _c("div", { staticClass: "w-full md_w-1-4 mt-1_25" }, [
            _c(
              "div",
              {
                staticClass: "md_p-2 ml-_375 md_mx-_5 md_bg-brand-secondary-50"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-4xl md_text-3xl text-brand-secondary-900 font-bold leading-none ml-1_25 md_ml-0"
                  },
                  [
                    _vm._v(_vm._s(_vm.category.category) + " "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-4xl md_text-3xl text-brand-secondary-900 font-bold leading-none inline-block md_block"
                      },
                      [_vm._v("Collection")]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-2 md_flex md_justify-center ml-_25 relative"
                  },
                  [
                    _c(
                      "scroll-gradient",
                      {
                        staticClass:
                          "md_flex md_flex-col whitespace-no-wrap md_whitespace-normal overflow-x-auto md_overflow-x-visible"
                      },
                      [
                        _vm._l(_vm.links, function(link) {
                          return _c(
                            "router-link",
                            {
                              key: link.id,
                              staticClass:
                                "collection-button cursor-pointer md_font-bold md_leading-loose md_hover_underline inline-block md_block",
                              attrs: {
                                tabindex: "0",
                                tag: "div",
                                to: {
                                  name: "marketplace",
                                  query: { category: link.id },
                                  params: { page: "1" }
                                }
                              }
                            },
                            [_vm._v(_vm._s(link.category))]
                          )
                        }),
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "collection-button cursor-pointer md_mt-2 md_hover_underline inline-block md_block",
                            attrs: {
                              tabindex: "0",
                              tag: "div",
                              to: {
                                name: "marketplace",
                                query: { category: _vm.category.id },
                                params: { page: "1" }
                              }
                            }
                          },
                          [
                            _vm._v("+ "),
                            _c(
                              "span",
                              { staticClass: "md_text-brand-secondary-900" },
                              [_vm._v("View All")]
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "div",
            { staticClass: "relative w-full md_w-3-4 flex" },
            [
              _c(
                "scroll-gradient",
                {
                  staticClass:
                    "whitespace-no-wrap overflow-x-auto md_overflow-x-visible md_whitespace-normal md_flex w-full"
                },
                _vm._l(_vm.campaigns, function(campaign) {
                  return _c("product", {
                    key: campaign.campaign_id,
                    staticClass: "md_w-1-3",
                    attrs: {
                      campaign: campaign,
                      "utm-source": _vm.utmSource,
                      affiliate: _vm.config.AFFILIATE_ID,
                      "currency-info": _vm.currencyInfo
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }